module.exports = __webpack_public_path__ + "media/images/head-e0704bfe4c5b02a44bdca1e11a526c72.svg";